import _ from 'underscore';
import Promise from 'bluebird';

/**
 * Converts the list of errors in a TaskItemExecution to localized error messages.
 * @param {Object[]} options.errors - List of errors that occurred during execution.
 * @param {function} options.getODataErrors - Function to parse odata errors from AJAX response.
 * @param {Object} options.i18n - i18n library.
 * @returns {Promise.AggregateError} - List of localized error messages.
 */
export function convertServerSideErrors({
  errors,
  getODataErrors,
  i18n,
}) {
  const serverErrors = _.uniq(getODataErrors(errors), false, error => error.message);

  const aggregateError = new Promise.AggregateError();

  if (_.isEmpty(serverErrors)) {
    aggregateError.push(new Error(i18n.getString('GridDownloadFailureMessage')));
  }

  aggregateError.push(...serverErrors);
  aggregateError.message = i18n.formatList(serverErrors.map(err => err.message));
  return aggregateError;
}
